<template>
<div id="new-contract-01">
    <div class="container mt-4 pr-4 pl-4 pb-1">
        <h3 class="font-weight-normal mb-4">ผ่อนผันหรือเปลี่ยนแปลงสัญญา</h3>
        <div class="row mb-4">
            <div class="col">
                <router-link class="card shadow" :to="{ name: 'transaction-contract-change-status-form', params: { id: this.$route.params.id } }">
                    <div class="card-body text-center text-dark p-4">
                        <img class="mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/contract-money@2x.png')" />
                        <h3 class="font-weight-normal">ปรับสัญญาใหม่</h3>
                        <p class="m-0 text-secondary">สร้างสัญญาใหม่เป็นสัญญาย่อย โดยกำหนดวงเงินและอัตราดอกเบี้ยใหม่ งวดใหม่ตามที่ตกลงใหม่ การชำระเงินมีผลทันที</p>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col">
                <div class="card shadow">
                    <div class="card-body text-center text-dark p-4">
                        <h3 class="font-weight-normal">ผ่อนผันการชำระ</h3>
                        <p class="m-0 text-secondary">สร้างเงื่อนไขการชำระตามที่กำหนดดังต่อไปนี้</p>

                        <div class="row">
                            <div class="col">
                                <div class="form-group form-goobank" style="width:50px; margin:0 auto;">
                                    <label for="duration">งวดที่</label>
                                    <select :disabled="isExemptActive" class="form-control is-default" name="fromPeriod" v-model="fromPeriod">
                                        <template v-for="option in allPeriods">
                                            <option :key="option.value" :value="option.value">{{option.display}}</option>
                                        </template>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group form-goobank" style="width:50px; margin:0 auto;">
                                    <label for="duration">งวดที่</label>
                                    <select :disabled="isExemptActive" class="form-control is-default" name="toPeriod" v-model="toPeriod">
                                        <template v-for="option in allPeriods">
                                            <option :key="option.value" :value="option.value">{{option.display}}</option>
                                        </template>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div style="margin:20px auto; width:200px;">
                            <div class="custom-control custom-checkbox" @click="toggleOnlyInterest">
                                <input class="custom-control-input" :class="{ 'is-invalid': errors.has('borrowerPayOnlyInterest') }" type="checkbox" v-model="borrowerPayOnlyInterest"/>
                                
                                
                                <label v-if="contract.type != 'MORTGAGE'" class="custom-control-label text-secondary" for="borrowerPayOnlyInterest">ให้ลูกหนี้ชำระแค่เงินต้น</label>
                                <label v-else class="custom-control-label text-secondary" for="borrowerPayOnlyInterest">ให้ลูกหนี้ชำระแค่ค่างวดเพื่อลดเงินต้น</label>
                            </div>
                        </div>

                        <button v-if="!isExemptActive" :disabled="isDisabled()" @click="createNewContractCondition()" class="btn btn-primary btn-lg btn-block">สร้างเงื่อนไขสัญญานี้</button>
                        <button v-else @click="cancelExemptContractCondition()" class="btn btn-danger btn-lg btn-block">ยกเลิกเงื่อนไขสัญญานี้</button>

                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-4 pb-2">
            <div class="col"><a class="btn btn-light btn-lg btn-block" @click="goBack">ย้อนกลับ</a></div>
        </div>
    </div>
</div>
</template>

<script>

export default {
  data: () => ({
      contract: {
        id: -1,
        type: '', // 'MONEY' or 'THING'
      },
      borrowerPayOnlyInterest: false,
      fromPeriod: null,
      toPeriod: null,
      isExemptActive: false,
      fromInitialPeriod: 5,
      toInitialPeriod: 20,
      allPeriods: [],
  }),
  async created () {
      this.populateAllPeriods();
  },
  methods: {
    async populateAllPeriods () {
        this.allPeriods = [];
        const result1 = await this.$api.contract.list(this.$route.params.id);
        const data = result1.data
        if (!data.success) {
            this.isCantReach = true
            this.errorData = data
            return
        }
        this.contract = data.contracts[0];

        const result = await this.$api.contract.listExempt(this.$route.params.id);

        this.fromInitialPeriod = result.data.exempt_initial_from_period;
        this.toInitialPeriod = result.data.exempt_initial_to_period;

        for(let i = this.fromInitialPeriod; i <= this.toInitialPeriod; i++) {
            let display = "" + i;
            this.allPeriods.push({
                value: i,
                display: display
            });
        }

        this.isExemptActive = result.data.is_exempt;
        if(this.isExemptActive) {
            this.fromPeriod = result.data.exempt_start_period;
            this.toPeriod = result.data.exempt_end_period;
            this.borrowerPayOnlyInterest = true;
        } else {
            this.fromPeriod = this.fromInitialPeriod;
            this.toPeriod = this.toInitialPeriod;
            this.borrowerPayOnlyInterest = false;
        }
    },
    isDisabled() {
        return !this.borrowerPayOnlyInterest || (this.fromPeriod > this.toPeriod);
    },
    goBack () {
      this.$router.push({ name: 'transaction-contract-view', params: { id: this.$route.params.id } });
    },
    toggleOnlyInterest() {
        this.borrowerPayOnlyInterest = !this.borrowerPayOnlyInterest;
        return false;
    },
    async createNewContractCondition() {
        let patch = {
            'exempt_start_period': this.fromPeriod,
            'exempt_end_period': this.toPeriod,
        };

        const result = await this.$api.contract.updateExempt(this.$route.params.id, patch);
        alert("ทำการผ่อนผันแล้ว");
        this.$router.push({ name: 'transaction-contract-view', params: { id: this.$route.params.id } });
    },
    async cancelExemptContractCondition() {
        const result = await this.$api.contract.cancelExempt(this.$route.params.id);
        alert("ยกเลิกผ่อนผันแล้ว");
        this.$router.push({ name: 'transaction-contract-view', params: { id: this.$route.params.id } });
    }
  }
}

</script>

<style lang="scss">
</style>